import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';
import HorseSireCell from '../components/DataTable/HorseSireCell';
import getYear from 'date-fns/get_year';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for sires table
 */
export default {
    url: `/bloodstock/sales/catalogues/${rootData.venueid}/${rootData.salesdate}/sires/data.json`,
    columns: [
        {
            columnName: 'sire_style_name',
            displayName: 'Sire',
            customCell: {
                component: HorseSireCell,
                options: {
                    horseUid: 'sire_uid',
                    horseName: 'sire_style_name'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'sire'
            }
        },
        {
            columnName: 'total_lots',
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-sm-up',
                            displayName: '#'
                        },
                        {
                            className: 'hidden-xs-down hidden-xl-up',
                            displayName: 'Lots'
                        },
                        {
                            className: 'hidden-lg-down',
                            displayName: 'No.Lots'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'lots'
            }
        },
        {
            columnName: 'total_lots_colts',
            displayName: 'No.Colts',
            headerDataAttrs: {
                [DATA_TITLE]: 'no-colts'
            }
        },
        {
            columnName: 'total_lots_fillies',
            displayName: 'No.Fillies',
            headerDataAttrs: {
                [DATA_TITLE]: 'no-fillies'
            }
        },
        {
            columnName: 'stud_fee',
            displayName: `${getYear(rootData.salesdate)} fee`,
            headerDataAttrs: {
                [DATA_TITLE]: 'fee'
            }
        },
        {
            columnName: 'stud_name',
            displayName: 'STOOD',
            headerDataAttrs: {
                [DATA_TITLE]: 'stood'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/siresTable.js